<template>
  <div class="import-data">
    <!-- 上传 start -->
    <el-dialog
      title="批量短信"
      :visible.sync="updateVisuble"
      :close-on-click-modal="false"
      width="480px"
    >
      <el-upload
        class="upload-demo"
        action=""
        drag
        multiple
        :http-request="({ file }) => (excelFile = file)"
        :show-file-list="false"
        v-loading="loadingFile"
      >
        <i class="el-icon-upload"></i>
        <p>{{ excelFile ? excelFile.name : '上传文件' }}</p>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateVisuble = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleDownloadTemplate">下载模板</el-button>
        <el-button type="primary" size="small" @click="handleUpdate">上 传</el-button>
      </div>
    </el-dialog>
    <!-- 上传 end -->
  </div>
</template>

<script>
export default {
  name: "ImportData",
  data() {
    return {
      updateVisuble: false,
      updateType: null,
      companyType: "1",
      excelFile: null,
      loadingFile: false
    };
  },
  methods: {
    // 打开上传对话框
    openDialog(type = 1) {
      this.updateType = type;
      this.updateVisuble = true;
      this.excelFile = null;
      this.companyType = "1";
    },

    // 上传文件
    async handleUpdate() {
      if (!this.excelFile) {
        this.$message({
          showClose: true,
          message: "请先选择文件",
          type: "warning"
        });
        return;
      }

      const formData = new FormData();
      formData.append("file", this.excelFile);
      try {
        this.loadingFile = true;
        const res = await this.$API.importSmsSendInfo(formData);
        if(res.data.code !== 200) throw { msg: res.data.msg || "上传失败" }
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        this.updateVisuble = false;
        this.excelFile = null;
        this.$emit("refresh"); // 通知父组件刷新数据
      } catch (error) {
        this.$message({
          showClose: true,
          message: error.msg || "上传失败",
          type: "error"
        });
      } finally {
        this.loadingFile = false;
      }
    },

    // 下载模板
    async handleDownloadTemplate() {
      try {
        window.open("/smsSend/downloadSmsSendTemplate");
        // const res = await this.$API.downloadAuthTemplate();
        // const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement("a");
        // link.href = url;
        // link.download = `权限转移模板.xlsx`;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$message({
          showClose: true,
          message: "下载模板失败",
          type: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.import-data {
  .upload-demo {
    ::v-deep .el-upload {
      width: 100%;
    }

    ::v-deep .el-upload-dragger {
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    ::v-deep .el-icon-upload {
      font-size: 48px;
      color: #409eff;
      margin-top: 0;
      margin-bottom: 10px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
